export default __webpack_public_path__ + "static/media/tag.4928b699.png";